import React from "react";

import { viewBoardingPagePermissionSet } from "helpers";
import { getTidEquipmentAppLink } from "mappers";
import { useTidEquipmentSearchQuery } from "queries";

import { tidEquipmentResultItem } from "../resultItems";

import { ReactComponent as TidEquipmentRequestIcon } from "static/images/tid_equipment_search.svg";

const tidEquipmentSection = () => {
	return {
		name: "tidEquipmentRequest",
		title: "TID Request & Equipment Request",
		useSearchQuery: useTidEquipmentSearchQuery,
		renderItem: tidEquipmentResultItem,
		getIcon: () => <TidEquipmentRequestIcon />,
		getLink: ({ application_status, id }) =>
			getTidEquipmentAppLink(application_status, id),
		requiredPermissions: viewBoardingPagePermissionSet,
	};
};

export default tidEquipmentSection;
